// extracted by mini-css-extract-plugin
export default {"container":"CommingSoon_container__qtCsg","popup":"CommingSoon_popup__+g99g"};